import { useCallback, useEffect, useState } from 'react';
import { cookiesClient } from '@frodo/lib/utils/client';

export type UseCookiesOptions = {
  expiration?: number;
  path?: string;
};

type UseCookiesType = [state: string, setValue: (value: string) => void];

export const useCookies = (
  name: string,
  options: UseCookiesOptions = {},
): UseCookiesType => {
  const { expiration = 0, path } = options;
  const [state, setState] = useState('');

  useEffect(() => {
    setState(cookiesClient.get(name));
  }, [name]);

  const setValue = useCallback(
    (value: string) => {
      if (!value) {
        cookiesClient.remove(name, path);
        setState('');
        return;
      }

      cookiesClient.add(name, value, expiration, path);
      setState(value);
    },
    [name, expiration, path],
  );

  return [state, setValue];
};
